import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const generateGridContainerClassNames = ({ fullWidth, extraGridContainerClassNames }) => classNames({
  'grid-container text--center': true,
  'full': fullWidth,
  [`${extraGridContainerClassNames}`]: extraGridContainerClassNames,
});

export const generateGridRowClassNames = ({
  alignCenter,
  noGutters,
}) => classNames({
  'medium-margin-collapse': noGutters,
  'align-center': alignCenter,
});

const HeroGridWrapper = ({
  children,
  alignCenter,
  extraGridContainerClassNames,
  fullWidth,
  noGutters,
}) => (
  <div className={generateGridContainerClassNames({ fullWidth, extraGridContainerClassNames })}>
    <div className={
      generateGridRowClassNames({
        fullWidth,
        alignCenter,
        noGutters,
      })}
    >
      {children}
    </div>
  </div>
);

HeroGridWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  alignCenter: PropTypes.bool,
  fullWidth: PropTypes.bool,
  noGutters: PropTypes.bool,
  extraGridContainerClassNames: PropTypes.string,
};

export default HeroGridWrapper;
